import {
  ExperimentsAction,
  ExperimentAnalyticsBasePageState,
  ExperimentAnalyticsLoadingState,
  ExperimentAnalyticsErrorState,
} from 'modules/experiments/types';
import { initialAnalyticsBasePageData } from 'modules/experiments/constants';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';

export const initialAnalyticsBasePageState: ExperimentAnalyticsBasePageState = {
  data: initialAnalyticsBasePageData,
  [ExperimentAnalyticsLoadingState.PAGE]: false,
  [ExperimentAnalyticsErrorState.PAGE]: false,
};

export const experimentAnalyticsBasePageReducer = (
  state = initialAnalyticsBasePageState,
  action?: ExperimentsAction,
) => {
  switch (action?.type) {
    case ActionTypes.ANALYTICS_PAGE_LOADED:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PAGE]: true,
        [ExperimentAnalyticsErrorState.PAGE]: false,
      };

    case ActionTypes.SET_ANALYTICS_BASE_PAGE_DATA: {
      const basePageData = action?.payload;
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PAGE]: false,
        [ExperimentAnalyticsErrorState.PAGE]: false,
        data: basePageData || state.data,
      };
    }

    case ActionTypes.UPDATE_EXPERIMENT_NAME:
      return {
        ...state,
        data: {
          ...state.data,
          name: action?.name || state.data.name,
        },
      };

    case ActionTypes.ANALYTICS_BASE_PAGE_DATA_ERROR:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.PAGE]: false,
        [ExperimentAnalyticsErrorState.PAGE]: true,
      };

    default:
      return state;
  }
};
